import { render } from "./DialogPanel.vue?vue&type=template&id=3f171086&scoped=true"
import script from "./DialogPanel.vue?vue&type=script&lang=js"
export * from "./DialogPanel.vue?vue&type=script&lang=js"

import "./DialogPanel.vue?vue&type=style&index=0&id=3f171086&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f171086"

export default script